exports["DE"] = require("./DE.js");
exports["CH"] = require("./CH.js");